import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';

//SERVICE
import { TranslateServiceApi } from "../services/translate.service";
//SERVICE
import { ForAllService } from "../services/forall.service";
import { BroadcastService } from '../broadcast.service';
import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';



@Component({
    selector     : 'translate',
    templateUrl  : './translate.component.html',
    styleUrls    : ['./translate.component.scss'],

    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class TranslateComponent implements OnInit, OnDestroy{

    subscription: Subscription;


    animationDirection: 'left' | 'right' | 'none';
    course: any[];
    courseStepContent: any;
    currentStep: number;
    idiomasAdicionales: any;
    flagMensaje: boolean = false;
    displayedColumns :any;
    response:any;
    dataSource = [];
    translateGet:any;
    @Input('pasoCompleto') pasoCompleto?: boolean;

    @ViewChildren(FusePerfectScrollbarDirective)
    fuseScrollbarDirectives: QueryList<FusePerfectScrollbarDirective>;

    // Private
    private _unsubscribeAll: Subject<any>;


    constructor(
        private translateService: TranslateServiceApi,
        private serviceTranslate: TranslateService,
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseSidebarService: FuseSidebarService,
        private forallService: ForAllService,
        public snackBar: MatSnackBar,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private broadcast: BroadcastService)
    {
        lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_idiomas.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        // subscribe to product component
       this.subscription = this.broadcast.getEvent().subscribe(product => {

          this.getPracticesSaved();

        });

        // Set the defaults
        this.animationDirection = 'none';
        this.currentStep = 0;

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }


    ngOnInit(): void{

      this.course = [];

    }



    ngOnDestroy(): void{
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    /**
     * Go to step
     *
     * @param step
     */
    gotoStep(step): void{
        // Decide the animation direction
        this.animationDirection = this.currentStep < step ? 'left' : 'right';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Set the current step
        this.currentStep = step;
    }

    /**
     * Go to next step
     */
    gotoNextStep(): void{
        if ( this.currentStep === this.course.length - 1 ){
            return;
        }

        // Set the animation direction
        this.animationDirection = 'left';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Increase the current step
        this.currentStep++;
    }

    /**
     * Go to previous step
     */
    gotoPreviousStep(): void{
        if ( this.currentStep === 0 ){
            return;
        }

        // Set the animation direction
        this.animationDirection = 'right';

        // Run change detection so the change
        // in the animation direction registered
        this._changeDetectorRef.detectChanges();

        // Decrease the current step
        this.currentStep--;
    }

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void{
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

  private getPracticesSaved(){
    let data = {"fechaCertificar": localStorage.getItem('fechaProducto')};
    this.forallService.getPracticesSaved(data)
      .subscribe(response => {
        let status = response['message'];
        if(status == 200){
            this.course = response['practicas'];
            this.getLanguajesList();

        }


    }, error => {
      console.log("error", error);
    })
  }

  private filterArray(dato:string){

   let aux = this.translateGet.length;
    for (let j = 0; j < aux; j++) {

       if(this.translateGet[j]['idioma'] == dato){
         return j;
       }
     }
     return null;
 }

  private getLanguajesList(){
    let data = {
      fechaCertificar:localStorage.getItem('fechaProducto')
    };
      this.translateService.getLanguajesListSelected(data)
      .subscribe(response => {
        // console.log(response);
        let res2 = [];

        if(response['idiomasMostrar'].length > 0){
          this.flagMensaje = true;
        }

      for (let i = 0; i < response['idiomasMostrar'].length; i++) {
          let res = [];

          for (let j = 0; j < this.course.length; j++) {
            let aux = 0;
            let pract = '';
            let desc = '';

              this.translateGet = this.course[j]['traducciones'];

              aux = this.filterArray(response['idiomasMostrar'][i]['_id']);
              if(aux != null){


                 if(this.translateGet[aux]['practicaForall'] != null){
                    pract = this.translateGet[aux]['practicaForall'];
                  }

                  if(this.translateGet[aux]['descripcionForall'] != null){
                    desc = this.translateGet[aux]['descripcionForall'];
                  }

                res.push({'idPractica':this.course[j]['_id'],'practNativo':this.course[j]['practicaForall'],'descNativo':this.course[j]['descripcionForall'],
                    'lenguaje':response['idiomasMostrar'][i]['nombreIdioma'],
                    'id':response['idiomasMostrar'][i]['_id'],
                    'practice':pract,
                    'description':desc});
              }else{
                res.push({'idPractica':this.course[j]['_id'],'practNativo':this.course[j]['practicaForall'],'descNativo':this.course[j]['descripcionForall'],
                    'lenguaje':response['idiomasMostrar'][i]['nombreIdioma'],
                    'id':response['idiomasMostrar'][i]['_id'],
                    'practice':'',
                    'description':''});

              }
          }

          res2.push({'nombreIdioma': response['idiomasMostrar'][i]['nombreIdioma'],
                      'tipoIdioma': response['idiomasMostrar'][i]['tipoIdioma'],
                      'vivoIdioma': response['idiomasMostrar'][i]['vivoIdioma'],
                      '_id': response['idiomasMostrar'][i]['_id'],
                      'arreglo':res});
      }
      this.response = res2;
      // console.log(this.response);

      this.idiomasAdicionales = response['idiomasMostrar'];

      }, error => {
        console.log("error", error);
      })
  }

  private onBlurPractica(event,idForall,idIdioma){

  if(event.target.value.length >= 1){
    let data = {"fechaCertificar":localStorage.getItem('fechaProducto'),
                  "idForall":idForall,
                  practicaForall: event.target.value,
                  idiomaId: idIdioma
                };

    this.translateService.insertTranslate(data)
      .subscribe(response => {

        console.log(response);

        if(response['message'] == 'Success: Traducción actualizada'){
          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_TRANSLATEREGISTERED'),this.serviceTranslate.instant('ALERTS.OK'));
            //this.openSuccessSnackBar('Practice translated successfully','OK');
        }


      }, error => {
        console.log("error", error);
      })
  }
}


private onBlurDescripcion(event,idForall,idIdioma){

  if(event.target.value.length >= 1){
    let data = {"fechaCertificar":localStorage.getItem('fechaProducto'),
                  "idForall":idForall,
                  descripcionForall: event.target.value,
                  idiomaId: idIdioma
                };

    this.translateService.insertTranslate(data)
      .subscribe(response => {

        console.log(response);

        if(response['message'] == 'Success: Traducción actualizada'){
          this.openSuccessSnackBar(this.serviceTranslate.instant('CERTIFICAR.FORALL.MSJ_DESCRIPTIONTRANSLATED'),this.serviceTranslate.instant('ALERTS.OK'));
            //this.openSuccessSnackBar('Description translated successfully','OK');
        }

      }, error => {
        console.log("error", error);
      })
  }
}

openErrorSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
       duration: 5000,
       verticalPosition: 'top',
       panelClass: ['background-red']
    });
 }


 openSuccessSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
       duration: 5000,
       verticalPosition: 'top',
       panelClass: ['background-success']
    });
 }


}
